import * as React from 'react';

export interface CheckboxGroupContextValue {
    value: string[];
    onChange?: (event: React.ChangeEvent<HTMLInputElement> | string) => void;
}

export const CheckboxGroupContext = React.createContext<CheckboxGroupContextValue | undefined>(undefined);

export function useCheckboxGroupContext(): CheckboxGroupContextValue | undefined {
    return React.useContext(CheckboxGroupContext);
}
